import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import { useState } from 'react';
import { api } from '../../maps/data.js';
import { useEffect } from 'react';
import Icn from '../Icn';
import Grid from '@mui/material/Grid';
import IconBtn from '../IconBtn';
import StepFieldItem from "../StepFieldItem";
import useZibi from "../../zibi/UseZibi";
import SensorStatus from "../SensorStatus";

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CameraItem from '../CameraItem';
import SensorTestDialog from "../testSensor/SensorTestDialog";
import Floor from "./Floor";
import ActionsPanel from "./ActionsPanel";

export const INITIAL_STEPS = { url: '', vertical: 0, horizontal: 0, scale: 0, zoom: 0, rotate: 0, opacity: 1 };

export default function FloorDialog(props) {
    const { onClose, floor, selectedSiteType, floorName, edgeId, siteId, knn } = props;

    const [sensorStatuses] = useZibi('sensorStatuses');

    const [tick, s_tick] = useState(1);
    const [floor_width, s_floor_width] = useState(floor?.width || 700);
    const [floor_height, s_floor_height] = useState(floor?.height || 400);
    const [floor_stage_steps, s_floor_stage_steps] = useState(floor?.floorEdgeSteps || []);
    const [floor_stage_fields, s_floor_stage_fields] = useState(floor?.floorEdgeFields || []);
    const [floor_stage_cameras, s_floor_stage_cameras] = useState(floor?.floorEdgeCameras || []);

    const [steps, s_steps] = useState([]);
    const [fields, s_fields] = useState([]);
    const [cameras, s_cameras] = useState([]);
    const [floor_selected_item, s_floor_selected_item] = useState(-1);

    const [check_in_display, s_check_in_display] = useState(true);
    const [check_in_rect, s_check_in_rect] = useState(props.checkin || []);
    const [check_in_draw_mode, s_check_in_draw_mode] = useState(false);

    const [check_out_display, s_check_out_display] = useState(true);
    const [check_out_rect, s_check_out_rect] = useState(props.checkout || []);
    const [check_out_draw_mode, s_check_out_draw_mode] = useState(false);
    const [moveIntervalId, setMoveIntervalId] = useState(null);
    const [rotateIntervalId, setRotateIntervalId] = useState(null);

    const [expanded, setExpanded] = React.useState(false);
    const [selected_factors, s_selected_factors] = useState({});
    const [muted_sensors, s_muted_sensors] = useState([]);
    const [testSensorDialogSensor, s_testSensorDialogSensor] = useState("");

    const [knns, s_knns] = useState(knn || []);
    const [knnsDrawModeIndex, s_knnsDraModeIndex] = useState(null);
    const [show_knns, s_show_knns] = useState(false);

    const [show_camera, s_show_camera] = useState(true);
    const [show_fields, s_show_fields] = useState(true);
    const [show_steps, s_show_steps] = useState(true);

    const [resizeAreaSelected, s_resizeAreaSelected] = useState(null);
    const [selectedImage, setSelectedImage] = useState(floor?.imageMetadata || INITIAL_STEPS);
    const [isImageNew, setIsImageNew] = useState(!floor?.imageMetadata?.imageFileName);

    const AREA_MARGIN = 5;

    useEffect(() => {
        setIsImageNew(!!selectedImage.url);
    }, [selectedImage.url]);

    const shelves = [];
    const unAssignedSensors = [];
    fields.forEach(field => {
        field?.shelves?.forEach(item => {
            shelves.push(item);
            unAssignedSensors.push(item.sensor);
        });
    });
    floor_stage_fields.forEach(field => {
        field?.field?.shelves?.forEach(item => {
            shelves.push(item);
            unAssignedSensors.push(item.sensor);
        });
    });
    steps.forEach(item => {
        unAssignedSensors.push(item);
    });


    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const save = async (e) => {
        await api({
            type: 'edgeSaveFloor',
            data: {
                edgeId: edgeId,
                checkout: check_out_rect,
                checkin: check_in_rect,
                floor: {
                    isImageNew: isImageNew,
                    prevImageName: floor?.imageMetadata?.imageFileName,
                    imageMetadata: selectedImage,
                    height: floor_height,
                    width: floor_width,
                    floorEdgeSteps: floor_stage_steps,
                    floorEdgeFields: floor_stage_fields,
                    floorEdgeCameras: floor_stage_cameras
                },
                knn: knns.filter(item => item.area.yMin !== 0 && item.area.xMin !== 0)
            }
        });
        if (muted_sensors.length) {
            const promises = muted_sensors.map(sensor => {
                return api({ type: "editSensor", data: { mute: sensor.mute, sensorId: sensor.sensorId } });
            });
            await Promise.all(promises);
        }
        onClose(e);
    };

    const getStep = async () => {
        const steps_res = await api({ type: 'getSensors', data: { edgeId, type: 'step', only_unassignToFloor: true } });
        s_steps(steps_res);
    };

    const getFields = async () => {
        const field_res = await api({ type: 'getFields', data: { edgeId, type: 'step', only_unassignToFloor: true } });
        s_fields(field_res);
    };

    const getCameras = async () => {
        const camera_res = await api({ type: 'getCameras', data: { edgeId, only_unassignToFloor: true } });
        s_cameras(camera_res);
    };

    const editSensorMute = async () => {
        const sensor = floor_stage_steps.find((item) => item.sensorId === floor_selected_item);
        const mute = !sensor?.sensor?.mute;
        const sensorId = sensor.sensorId;

        let newSensorsList = [];
        const exists = muted_sensors.find(item => item.sensorId === sensorId);
        if (exists) {
            newSensorsList = muted_sensors.filter(item => item.sensorId !== sensorId);
        } else {
            newSensorsList.push({ sensorId: sensorId, mute: mute });
        }

        s_muted_sensors(newSensorsList);

        s_floor_stage_steps(floor_stage_steps.map(step => {
            if (sensor.sensorId === step.sensorId) {
                const sensorItem = step?.sensor;
                sensorItem.mute = mute;
            }
            return step;
        }));
    };

    const editSensorMuteUnassigned = async (sensorId) => {
        const sensor = unAssignedSensors.find((item) => item._id === sensorId);
        const mute = !sensor?.mute;

        let newSensorsList = [];
        const exists = muted_sensors.find(item => item.sensorId === sensorId);
        if (exists) {
            newSensorsList = muted_sensors.filter(item => item.sensorId !== sensorId);
        } else {
            newSensorsList.push({ sensorId: sensorId, mute: mute });
        }

        s_muted_sensors(newSensorsList);

        s_steps(steps.map(step => {
            if (sensorId === step._id) {
                step.mute = mute;
            }
            return step;
        }));
        s_floor_stage_fields(floor_stage_fields.map(field => {
            field?.field?.shelves?.forEach(item => {
                if (sensorId === item.sensorId) {
                    const sensorItem = item?.sensor;
                    sensorItem.mute = mute;
                }
            });
            return field;
        }));
        s_fields(fields.map(field => {
            field?.shelves?.forEach(item => {
                if (sensorId === item.sensorId) {
                    const sensorItem = item?.sensor;
                    sensorItem.mute = mute;
                }
            });
            return field;
        }));
    };

    const testSensorHandle = async () => {
        const sensor = floor_stage_steps.find((item) => item.sensorId === floor_selected_item);
        s_testSensorDialogSensor(sensor);
    };

    useEffect(() => {
        getStep();
        getFields();
        getCameras();
    }, []);

    const addStepToStage = idx => {
        let _steps = steps.concat();
        const the_step = Object.assign({}, steps[idx]);
        _steps.splice(idx, 1);
        s_steps(_steps);
        s_floor_stage_steps(floor_stage_steps.concat({
            sensor: the_step,
            sensorId: the_step._id,
            xFactor: 0,
            yFactor: 0
        }));
        s_floor_selected_item(the_step._id);

        setSelectedFactors();
    };

    const addFieldToStage = idx => {
        let _fields = fields.concat();
        const the_field = Object.assign({}, fields[idx]);
        _fields.splice(idx, 1);
        s_fields(_fields);
        s_floor_stage_fields(floor_stage_fields.concat({
            field: {
                name: the_field.name,
                piNumber: the_field.piNumber,
                width: the_field.width,
                height: the_field.height
            }, fieldId: the_field._id, xFactor: 0, yFactor: 0
        }));
        s_floor_selected_item(the_field._id);

        setSelectedFactors();
    };

    const addCameraToStage = idx => {
        let _cameras = cameras.concat();
        const the_camera = Object.assign({}, cameras[idx]);
        _cameras.splice(idx, 1);
        s_cameras(_cameras);
        s_floor_stage_cameras(floor_stage_cameras.concat({
            camera: {
                name: the_camera.name,
                piNumber: the_camera.piNumber,
                width: the_camera.width,
                height: the_camera.height
            }, cameraId: the_camera._id, xFactor: 0, yFactor: 0
        }));
        s_floor_selected_item(the_camera._id);

        setSelectedFactors();
    };

    const onLongMoveHandle = (e, vector) => {
        if (moveIntervalId) {
            clearInterval(moveIntervalId);
            setMoveIntervalId(null);
        }
        const intId = setInterval(() => {
            move(vector, e);
        }, 20);
        setMoveIntervalId(intId);
    };

    const onLongRotateHandle = (e, vector) => {
        if (rotateIntervalId) {
            clearInterval(rotateIntervalId);
            setRotateIntervalId(null);
        }
        const intId = setInterval(() => {
            rotate(null, e);
        }, 20);
        setRotateIntervalId(intId);
    };

    const setSelectedFactors = () => {

        let x = 0, y = 0;

        floor_stage_steps.map(step => {
            if (floor_selected_item === step.sensorId) {
                x = step.xFactor;
                y = step.yFactor;
            }
        });

        floor_stage_fields.map(field => {
            if (floor_selected_item === field.fieldId) {
                x = field.xFactor;
                y = field.yFactor;
            }
        });

        floor_stage_cameras.map(camera => {
            if (floor_selected_item === camera.cameraId) {
                x = camera.xFactor;
                y = camera.yFactor;
            }
        });

        s_selected_factors({ x, y });
    };

    const move = (vector, e) => {
        e.stopPropagation();
        e.preventDefault();

        let tickData = tick;
        if (e.shiftKey) {
            tickData = 15;
        }
        let x = 0, y = 0;
        switch (vector) {
            case 'down':
                y = tickData;
                break;
            case 'up':
                y = -tickData;
                break;
            case 'left':
                x = -tickData;
                break;
            case 'right':
                x = tickData;
                break;
        }
        s_floor_stage_steps(floor_stage_steps.map(step => {
            if (floor_selected_item === step.sensorId) {
                const sensor = step?.sensor;
                const sensorWidht = sensor?.width || 0;
                const sensorHeight = sensor?.height || 0;

                if (vector === 'down' || vector === 'right') {
                    step.xFactor = Math.min(step.xFactor + x, floor_width - sensorWidht);
                    step.yFactor = Math.min(step.yFactor + y, floor_height - sensorHeight);
                } else {
                    step.xFactor = Math.max(step.xFactor + x, 0);
                    step.yFactor = Math.max(step.yFactor + y, 0);
                }
            }
            return step;
        }));

        s_floor_stage_fields(floor_stage_fields.map(field => {
            if (floor_selected_item === field.fieldId) {
                const sensor = field?.field;
                const sensorWidht = sensor?.width || 0;
                const sensorHeight = sensor?.height || 0;
                if (vector === 'down' || vector === 'right') {
                    field.xFactor = Math.min(field.xFactor + x, floor_width - sensorWidht);
                    field.yFactor = Math.min(field.yFactor + y, floor_height - sensorHeight);
                } else {
                    field.xFactor = Math.max(field.xFactor + x, 0);
                    field.yFactor = Math.max(field.yFactor + y, 0);
                }
            }
            return field;
        }));

        s_floor_stage_cameras(floor_stage_cameras.map(camera => {
            if (floor_selected_item === camera.cameraId) {
                const sensor = camera?.camera;
                const sensorWidht = sensor?.width || 0;
                const sensorHeight = sensor?.height || 0;
                if (vector === 'down' || vector === 'right') {
                    camera.xFactor = Math.min(camera.xFactor + x, floor_width - sensorWidht);
                    camera.yFactor = Math.min(camera.yFactor + y, floor_height - sensorHeight);
                } else {
                    camera.xFactor = Math.max(camera.xFactor + x, 0);
                    camera.yFactor = Math.max(camera.yFactor + y, 0);
                }
            }
            return camera;
        }));

        setSelectedFactors();
    };

    const mirror = e => {
        e.stopPropagation();
        e.preventDefault();

        s_floor_stage_steps(floor_stage_steps.map(step => {
            if (floor_selected_item === step.sensorId) {
                step.isMirror = !step.isMirror;
            }
            return step;
        }));
    }

    const rotate = (direction, e) => {

        e.stopPropagation();
        e.preventDefault();

        let tickData = tick;
        if (e.shiftKey) {
            tickData = 15;
        }

        // s_floor_stage_steps(floor_stage_steps.map(step => {
        //     if (floor_selected_item === step.sensorId) {
        //         step.rotate = !step.rotate ? 90 : (step.rotate + 90);
        //         step.rotate = step.rotate === 360 ? 0 : step.rotate;
        //     }
        //     return step;
        // }));

        s_floor_stage_steps(floor_stage_steps.map(step => {
            if (floor_selected_item === step.sensorId) {
                if (!step.rotate) {
                    step.rotate = 0;
                }

                step.rotate = step.rotate + tickData;
                if (step.rotate < 0) {
                    step.rotate = 0;
                }

                if (step.rotate > 359) {
                    step.rotate = 0;
                }

                const width = step?.sensor?.width || 96;
                const height = step?.sensor?.height || 36;
                const halfW = width / 2;
                const halfH = height / 2;
                step.xCenter = step.xFactor + halfW;
                step.yCenter = step.yFactor + halfH;
            }
            return step;
        }));

        s_floor_stage_fields(floor_stage_fields.map(field => {
            if (floor_selected_item === field.fieldId) {
                // field.rotate = !field.rotate ? 90 : (field.rotate + 90);
                // field.rotate = field.rotate === 360 ? 0 : field.rotate;
                if (!field.rotate) {
                    field.rotate = 0;
                }

                field.rotate = field.rotate + tickData;
                if (field.rotate < 0) {
                    field.rotate = 0;
                }

                if (field.rotate > 359) {
                    field.rotate = 0;
                }

                const width = field?.sensor?.width || 96;
                const height = field?.sensor?.height || 36;
                const halfW = width / 2;
                const halfH = height / 2;
                field.xCenter = field.xFactor + halfW;
                field.yCenter = field.yFactor + halfH;
            }
            return field;
        }));


    };

    const removeFromFloor = () => {


        s_floor_stage_steps(floor_stage_steps.map(step => {
            if (floor_selected_item === step.sensorId) {
                s_steps(steps.concat(step.sensor));
                return false;
            }
            return step;
        }).filter(s => !!s));

        s_floor_stage_fields(floor_stage_fields.map(field => {
            if (floor_selected_item === field.fieldId) {
                s_fields(fields.concat(field.field));
                return false;
            }
            return field;
        }).filter(f => !!f));

        s_floor_stage_cameras(floor_stage_cameras.map(camera => {
            if (floor_selected_item === camera.cameraId) {
                s_cameras(cameras.concat(camera.camera));
                return false;
            }
            return camera;
        }).filter(c => !!c));

    };

    const editorMouseMove = e => {
        if (check_in_draw_mode || check_out_draw_mode || knnsDrawModeIndex !== null) {
            const pos = e.currentTarget.getBoundingClientRect();
            const x = (parseInt(e.clientX - pos.left - AREA_MARGIN));
            const y = (parseInt(e.clientY - pos.top - AREA_MARGIN));

            if (check_in_draw_mode) {
                if (check_in_rect.length) {
                    s_check_in_rect([check_in_rect[0], [x, y]]);
                }
            }
            if (check_out_draw_mode) {
                if (check_out_rect.length) {
                    s_check_out_rect([check_out_rect[0], [x, y]]);
                }
            }
            if (knnsDrawModeIndex !== null) {
                const tempKnn = [...knns];
                if (tempKnn[knnsDrawModeIndex].area.xMin !== 0 && tempKnn[knnsDrawModeIndex].area.yMin !== 0) {
                    tempKnn[knnsDrawModeIndex].area.xMax = x;
                    tempKnn[knnsDrawModeIndex].area.yMax = y;
                    s_knns(tempKnn);
                }
            }
        }
    };

    const editorMouseDown = e => {
        if (check_in_draw_mode || check_out_draw_mode || knnsDrawModeIndex !== null) {
            const pos = e.currentTarget.getBoundingClientRect();
            const x = (parseInt(e.clientX - pos.left - AREA_MARGIN));
            const y = (parseInt(e.clientY - pos.top - AREA_MARGIN));
            if (check_in_draw_mode) {
                s_check_in_rect([[x, y], [x, y]]);
            }
            if (check_out_draw_mode) {
                s_check_out_rect([[x, y], [x, y]]);
            }

            if (knnsDrawModeIndex !== null) {
                const tempKnn = [...knns];
                tempKnn[knnsDrawModeIndex].area.xMin = x;
                tempKnn[knnsDrawModeIndex].area.yMin = y;
                tempKnn[knnsDrawModeIndex].area.xMax = x;
                tempKnn[knnsDrawModeIndex].area.yMax = y;
                s_knns(tempKnn);
            }
        }
    };

    const editorMouseUp = e => {
        if (check_in_draw_mode || check_out_draw_mode || knnsDrawModeIndex !== null) {
            const pos = e.currentTarget.getBoundingClientRect();
            const x = (parseInt(e.clientX - pos.left - AREA_MARGIN));
            const y = (parseInt(e.clientY - pos.top - AREA_MARGIN));

            if (check_in_draw_mode) {
                s_check_in_rect([check_in_rect[0], [x, y]]);
                s_check_in_draw_mode(false);
            }
            if (check_out_draw_mode) {
                s_check_out_rect([check_out_rect[0], [x, y]]);
                s_check_out_draw_mode(false);
            }

            if (knnsDrawModeIndex !== null) {
                const tempKnn = [...knns];
                tempKnn[knnsDrawModeIndex].area.xMax = x;
                tempKnn[knnsDrawModeIndex].area.yMax = y;
                s_knns(tempKnn);
                s_knnsDraModeIndex(null);
            }
        }
    };

    const resizeAreaHandle = (pos, isInc) => {
        const type = resizeAreaSelected?.type;

        const updatedTick = isInc ? tick : - tick;

        switch (type) {
            case 'checkIn':
            case 'checkOut':
                const rect = type === 'checkIn' ? check_in_rect : check_out_rect;

                let x1 = rect[0][0];
                let y1 = rect[0][1];
                let x2 = rect[1][0];
                let y2 = rect[1][1];

                if (pos === "top") {
                    y1 = y1 - updatedTick;
                }

                if (pos === "right") {
                    x2 = x2 + updatedTick;
                }

                if (pos === "bottom") {
                    y2 = y2 + updatedTick;
                }

                if (pos === "left") {
                    x1 = x1 - updatedTick;
                }

                if (type === 'checkIn') {
                    s_check_in_rect([[x1, y1], [x2, y2]]);
                } else {
                    s_check_out_rect([[x1, y1], [x2, y2]]);
                }
                break;
            case 'knn':
                let xMin = resizeAreaSelected.area.xMin;
                let yMin = resizeAreaSelected.area.yMin;

                let xMax = resizeAreaSelected.area.xMax;
                let yMax = resizeAreaSelected.area.yMax;
                if (pos === "top") {
                    yMin = yMin - updatedTick;
                }

                if (pos === "right") {
                    xMax = xMax + updatedTick;
                }

                if (pos === "bottom") {
                    yMax = yMax + updatedTick;
                }

                if (pos === "left") {
                    xMin = xMin - updatedTick;
                }
                const tempKnn = [...knns];
                tempKnn[resizeAreaSelected.index].area.xMin = xMin;
                tempKnn[resizeAreaSelected.index].area.xMax = xMax;
                tempKnn[resizeAreaSelected.index].area.yMax = yMax;
                tempKnn[resizeAreaSelected.index].area.yMin = yMin;
                s_knns(tempKnn);
                break;
        }
    };

    const isSensorSelected = floor_stage_steps.find((item) => item.sensorId === floor_selected_item);

    return (
        <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullScreen={true}>

            <DialogTitle id="alert-dialog-title">
                <Icn style={{ position: 'relative', top: 4 }}>floor</Icn> <Tx>floor.builder</Tx> [{floorName}]
            </DialogTitle>

            <DialogContent>

                <Grid container spacing={2}
                    style={{ marginTop: 10, height: 'calc(100vh - 160px)', background: "#E7EBF0" }}
                >
                    <Grid
                        style={{ paddingLeft: 0, paddingTop: 0 }}
                        item xs={10}
                        onClick={() => {
                            s_floor_selected_item(-1);
                            setSelectedFactors();
                            s_resizeAreaSelected(null);
                        }}
                    >
                        <ActionsPanel
                            tick={tick}
                            s_tick={s_tick}
                            floor_width={floor_width}
                            s_floor_width={s_floor_width}
                            floor_height={floor_height}
                            s_floor_height={s_floor_height}
                            onLongMoveHandle={onLongMoveHandle}
                            onLongRotateHandle={onLongRotateHandle}
                            moveIntervalId={moveIntervalId}
                            rotateIntervalId={rotateIntervalId}
                            floor_selected_item={floor_selected_item}
                            move={move}
                            rotate={rotate}
                            mirror={mirror}
                            s_floor_selected_item={s_floor_selected_item}
                            setSelectedFactors={setSelectedFactors}
                            removeFromFloor={removeFromFloor}
                            isSensorSelected={isSensorSelected}
                            editSensorMute={editSensorMute}
                            testSensorHandle={testSensorHandle}
                            show_knns={show_knns}
                            s_show_knns={s_show_knns}
                            show_camera={show_camera}
                            s_show_camera={s_show_camera}
                            show_fields={show_fields}
                            s_show_fields={s_show_fields}
                            show_steps={show_steps}
                            s_show_steps={s_show_steps}
                            s_check_in_display={s_check_in_display}
                            check_in_display={check_in_display}
                            check_in_rect={check_in_rect}
                            s_check_in_rect={s_check_in_rect}
                            s_check_in_draw_mode={s_check_in_draw_mode}
                            s_check_out_display={s_check_out_display}
                            check_out_display={check_out_display}
                            check_out_rect={check_out_rect}
                            s_check_out_rect={s_check_out_rect}
                            s_check_out_draw_mode={s_check_out_draw_mode}
                            knns={knns}
                            s_knns={s_knns}
                            s_knnsDraModeIndex={s_knnsDraModeIndex}
                            selectedImage={selectedImage}
                            setSelectedImage={setSelectedImage}
                            selectedSiteType={selectedSiteType}
                        />

                        <Floor
                            onMouseMove={editorMouseMove}
                            onMouseDown={editorMouseDown}
                            onMouseUp={editorMouseUp}
                            floor_width={floor_width}
                            floor_height={floor_height}
                            show_steps={show_steps}
                            floor_stage_steps={floor_stage_steps}
                            show_fields={show_fields}
                            floor_selected_item={floor_selected_item}
                            sensorStatuses={sensorStatuses}
                            check_in_draw_mode={check_in_draw_mode}
                            s_floor_selected_item={s_floor_selected_item}
                            setSelectedFactors={setSelectedFactors}
                            floor_stage_fields={floor_stage_fields}
                            show_camera={show_camera}
                            floor_stage_cameras={floor_stage_cameras}
                            check_in_rect={check_in_rect}
                            check_in_display={check_in_display}
                            resizeAreaSelected={resizeAreaSelected}
                            s_resizeAreaSelected={s_resizeAreaSelected}
                            check_out_rect={check_out_rect}
                            check_out_display={check_out_display}
                            selected_factors={selected_factors}
                            show_knns={show_knns}
                            knns={knns}
                            resizeAreaHandle={resizeAreaHandle}
                            selectedImage={selectedImage}
                        />

                    </Grid>

                    <Grid item xs={2} style={{ height: "100%", overflowY: "auto", padding: "16px 2px 10px 16px" }}>
                        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <Typography>
                                    <Icn>field</Icn> <span style={{ fontSize: 20 }}><Tx>g.fields</Tx></span>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {
                                    fields.map((field, idx) => {
                                        return (
                                            <StepFieldItem
                                                key={idx}
                                                type="field"
                                                name={`${field.name}`}
                                            >
                                                <div className="hidden">
                                                    <IconBtn size="small"
                                                        style={{
                                                            position: 'absolute',
                                                            top: "40%",
                                                            left: "43%",
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => addFieldToStage(idx)}>add</IconBtn>
                                                </div>
                                            </StepFieldItem>);
                                    })
                                }
                            </AccordionDetails>
                        </Accordion>

                        {/* Step */}
                        {selectedSiteType !== 'Inventory' && (
                            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2bh-content"
                                    id="panel2bh-header"
                                >
                                    <Typography><Icn>sensor</Icn><span
                                        style={{ fontSize: 20 }}><Tx>g.step</Tx></span></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {
                                        steps.map((step, idx) => {
                                            const sensorStatusData = sensorStatuses[step._id];
                                            const status = sensorStatusData?.status;
                                            const statusUpdateAt = sensorStatusData?.statusUpdateAt;

                                            return (
                                                <StepFieldItem
                                                    key={idx}
                                                    type="step"
                                                    name={step.boardId}
                                                    isMuted={step.mute}
                                                >
                                                    <SensorStatus status={status} statusUpdateAt={statusUpdateAt}
                                                        size={10} />
                                                    <div className="hidden">
                                                        <IconBtn size="small"
                                                            style={{
                                                                position: 'absolute',
                                                                bottom: "-7px",
                                                                right: "40px",
                                                                cursor: 'pointer'
                                                            }}
                                                            title="Add"
                                                            onClick={() => addStepToStage(idx)}>add</IconBtn>

                                                        <IconBtn
                                                            onClick={() => {
                                                                editSensorMuteUnassigned(step._id);
                                                            }}
                                                            title={step?.mute ? 'Unmute' : 'Mute'}
                                                            style={{
                                                                position: 'absolute',
                                                                bottom: "-7px",
                                                                right: "2px",
                                                                cursor: 'pointer'
                                                            }}
                                                            size="small">
                                                            {step?.mute ? 'volumeMuteIcon' : 'volumeOffIcon'}
                                                        </IconBtn>
                                                    </div>
                                                </StepFieldItem>);
                                        })
                                    }
                                </AccordionDetails>
                            </Accordion>
                        )}

                        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3bh-content"
                                id="panel3bh-header"
                            >
                                <Typography><Icn style={{ position: 'relative', top: 4 }}>camera</Icn><span
                                    style={{ fontSize: 20 }}><Tx>g.cameras</Tx></span></Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {
                                    cameras.map((field, idx) => {
                                        return (
                                            <CameraItem
                                                key={idx}
                                                type="camera"
                                                name={`${field.name}`}
                                            >
                                                <div className="hidden">
                                                    <IconBtn size="small"
                                                        style={{
                                                            position: 'absolute',
                                                            top: "40%",
                                                            left: "43%",
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => addCameraToStage(idx)}>add</IconBtn>
                                                </div>
                                            </CameraItem>);
                                    })
                                }
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel3bh-content"
                                id="panel3bh-header"
                            >
                                <Typography><Icn style={{ position: 'relative', top: 4 }}>shelfIcon</Icn><span
                                    style={{ fontSize: 20 }}><Tx>g.shelves</Tx></span></Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {
                                    shelves.map((shelf, idx) => {
                                        return (
                                            <StepFieldItem
                                                key={idx}
                                                type="shelf"
                                                name={`${shelf?.sensor?.boardId}`}
                                                isMuted={shelf?.sensor?.mute}
                                            >
                                                <div className="hidden">
                                                    <IconBtn size="small"
                                                        style={{
                                                            position: 'absolute',
                                                            bottom: "-7px",
                                                            right: "40px",
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => s_testSensorDialogSensor(shelf)}>scienceIcon</IconBtn>
                                                    <IconBtn
                                                        onClick={() => {
                                                            editSensorMuteUnassigned(shelf?.sensor?._id);
                                                        }}
                                                        title={shelf?.sensor?.mute ? 'Unmute' : 'Mute'}
                                                        style={{
                                                            position: 'absolute',
                                                            bottom: "-7px",
                                                            right: "2px",
                                                            cursor: 'pointer'
                                                        }}
                                                        size="small">
                                                        {shelf?.sensor?.mute ? 'volumeMuteIcon' : 'volumeOffIcon'}
                                                    </IconBtn>
                                                </div>
                                            </StepFieldItem>);
                                    })
                                }
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>

            </DialogContent>

            <DialogActions>

                <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                <Button onClick={save}>
                    <Tx>g.save</Tx>
                </Button>

            </DialogActions>
            {testSensorDialogSensor && (
                <SensorTestDialog
                    edgeId={edgeId}
                    siteId={siteId}
                    sensor={testSensorDialogSensor}
                    onClose={() => s_testSensorDialogSensor("")}
                />
            )}
        </Dialog>);
}